const USER_EDIT_DATA_KEY = "USER_EDIT_DATA";
export const userEditStorage = {
    saveUserEditData: (userData) => {
        try {
            const dataToStore = Object.assign(Object.assign({}, userData), { timestamp: new Date().toISOString() });
            localStorage.setItem(USER_EDIT_DATA_KEY, JSON.stringify(dataToStore));
        }
        catch (error) {
            console.error("Error saving user edit data to local storage:", error);
        }
    },
    getUserEditData: () => {
        try {
            const data = localStorage.getItem(USER_EDIT_DATA_KEY);
            if (data) {
                return JSON.parse(data);
            }
            return null;
        }
        catch (error) {
            console.error("Error retrieving user edit data from local storage:", error);
            return null;
        }
    },
    clearUserEditData: () => {
        try {
            localStorage.removeItem(USER_EDIT_DATA_KEY);
        }
        catch (error) {
            console.error("Error clearing user edit data from local storage:", error);
        }
    },
    hasUserEditData: () => {
        return localStorage.getItem(USER_EDIT_DATA_KEY) !== null;
    },
};
